// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".watches-tooltip{\nmargin-top: -52px !important;\n}", "",{"version":3,"sources":["webpack://src/appstyle.css"],"names":[],"mappings":"AAAA;AACA,4BAA4B;AAC5B","sourcesContent":[".watches-tooltip{\nmargin-top: -52px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
